import { withFullScreen } from '@/components/FullScreen';

import { ROICurvesBase } from './ROICurves';

export const ROICurves = withFullScreen('ROICurves', ROICurvesBase);
